import { render } from "./FancyTitle.vue?vue&type=template&id=40ea03d1&scoped=true"
import script from "./FancyTitle.vue?vue&type=script&lang=js"
export * from "./FancyTitle.vue?vue&type=script&lang=js"

import "./FancyTitle.vue?vue&type=style&index=0&id=40ea03d1&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ea03d1"]])

export default __exports__